import React from "react";
import PricingView from "../../components/Pricing";

export default function Pricing() {
  return <PricingView />;
}
